import BorderSides from "%/dynamic-component-editor/options/border-sides";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan sheet segmented control: an unselected segment's border (border-sides shape).
export default class UnselectedBorder extends BorderSides {
  static userInterfaceComponent = {
    label: "Unselected Border",
    component: inspectorTools.NEW_BORDER_PICKER,
    useCustomLabel: true,
    useVerticalOrientation: true,
    useDefaultVariableLinking: false,
    props: {
      heading: "Unselected Border",
    },
  };
}
